<div class="chat-bot-wrapper" [class.dont-popup]="chatService.roomId!=''"  [class.chat-bot-wrapper-admin]="chatService.userType=='admin'">
    
  <div class="chat-bot-header">
    
    <div class="chat-bot-header-txt">
        חלון צ'ט
    </div>
    
    <div class="chat-bot-close close-wrapper" *ngIf="chatService.userType!='admin'" (click)="closeConnection()">
        <div>X</div>
      </div>

  </div>
  <div *ngIf="chatService.userType=='admin'" (click)="closeChat()" class="close-chat">
      סגור צ'אט
        </div>
  <div id="chat-bot-frame" *ngIf="chatService.userName && !isThereError" class="chat-bot-frame">
    <div class="msg-row" *ngFor="let item of chatService.msgList">
      <div class="msg-details-one">
          <div class="user-name">
              {{item.userName}}:
            </div>
            <div class="msg-txt" [innerHtml]="item.text">
            </div>
            
      </div>
      
      <div class="msg-date">
          {{item.date | date: 'dd/MM/yy hh:mm:ss'}}
      </div>
      
    </div>
    <div class="loader-frame" *ngIf="!chatService.adminIsOnLive">
      
      <div class="loader-txt">
        ממתין לנציג
      </div>
      <div class="chat-loader">

        </div>
    </div>    
    <div class="in-conversetion" *ngIf="chatService.inConversition">
      בשיחה עם נציג
      <audio controls autoplay>
          <source src="/assets/beep.mp3" type="audio/mpeg">
        </audio>
    </div>
  </div>
  <div class="chat-bot-frame chat-bot-frame-start"  *ngIf="!chatService.userName || isThereError">
      <div class="msg-row msg-row-start" [class.is-there-error]="isThereError">
          <div class="msg-details-one">
              <div class="user-name">
                </div>
                <div class="msg-txt" [innerHtml]="alertTxt">
                </div>
          </div>
          
          <div class="msg-date">
          </div>
          
        </div>
     
  </div>
  <div >
    <form class="chat-bot-input" (ngSubmit)="sendNewMsg()">
        <input type="text" name="currentMsg" id="chat-bot-input" autocomplete="off" [(ngModel)]="currentMsg"/>
        <div class="send-input" (click)="sendNewMsg()">
          <div>
              שלח
          </div>
          
        </div>
    </form>
    
  </div>
 
</div>
